import React from "react";

import { Props } from "./types";
import { Column } from "./column";
import styles from "./styles.scss";

function Loader(props: Props) {
  return (
    <div className={styles.loader}>
      <Column />
      <Column />
      <Column />
      <Column />
    </div>
  );
}

export { Loader };
